import { userStore } from "../store";

export const getPermissions = () => userStore.user.permissions;

export default getPermissions;
